module.exports = __webpack_public_path__ + "static/media/ic_order_taker.0cbe167a.png";